import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onUpdate", "onComplete"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { sync } from '../../frameloop/index.mjs';
import { animate } from '../legacy-popmotion/index.mjs';
import { animateStyle } from './index.mjs';
import { isWaapiSupportedEasing } from './easing.mjs';

/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
var sampleDelta = 10; //ms
function createAcceleratedAnimation(value, valueName, _ref) {
  var onUpdate = _ref.onUpdate,
    onComplete = _ref.onComplete,
    options = _objectWithoutProperties(_ref, _excluded);
  var keyframes = options.keyframes,
    _options$duration = options.duration,
    duration = _options$duration === void 0 ? 0.3 : _options$duration,
    _options$elapsed = options.elapsed,
    elapsed = _options$elapsed === void 0 ? 0 : _options$elapsed,
    ease = options.ease;
  /**
   * If this animation needs pre-generated keyframes then generate.
   */
  if (options.type === "spring" || !isWaapiSupportedEasing(options.ease)) {
    var sampleAnimation = animate(options);
    var state = {
      done: false,
      value: keyframes[0]
    };
    var pregeneratedKeyframes = [];
    var t = 0;
    while (!state.done) {
      state = sampleAnimation.sample(t);
      pregeneratedKeyframes.push(state.value);
      t += sampleDelta;
    }
    keyframes = pregeneratedKeyframes;
    duration = t - sampleDelta;
    ease = "linear";
  }
  var animation = animateStyle(value.owner.current, valueName, keyframes, _objectSpread(_objectSpread({}, options), {}, {
    delay: -elapsed,
    duration: duration,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: ease
  }));
  /**
   * Prefer the `onfinish` prop as it's more widely supported than
   * the `finished` promise.
   *
   * Here, we synchronously set the provided MotionValue to the end
   * keyframe. If we didn't, when the WAAPI animation is finished it would
   * be removed from the element which would then revert to its old styles.
   */
  animation.onfinish = function () {
    value.set(keyframes[keyframes.length - 1]);
    onComplete && onComplete();
  };
  /**
   * Animation interrupt callback.
   */
  return function () {
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */
    var currentTime = animation.currentTime;
    if (currentTime) {
      var _sampleAnimation = animate(options);
      value.setWithVelocity(_sampleAnimation.sample(currentTime - sampleDelta).value, _sampleAnimation.sample(currentTime).value, sampleDelta);
    }
    sync.update(function () {
      return animation.cancel();
    });
  };
}
export { createAcceleratedAnimation };